"use strict";
/*
 * Created on 01 07 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AdtFlag_1 = require("../../core/model/AdtFlag");
/**
 * @author Jaroslav Sevcik
 */
// tslint:disable:max-classes-per-file


var PriceClassificationFlag =
/*#__PURE__*/
function (_AdtFlag_1$AdtFlag) {
  _inherits(PriceClassificationFlag, _AdtFlag_1$AdtFlag);

  function PriceClassificationFlag() {
    _classCallCheck(this, PriceClassificationFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceClassificationFlag).apply(this, arguments));
  }

  _createClass(PriceClassificationFlag, null, [{
    key: "register",
    value: function register(ctor, tag) {
      return AdtFlag_1.AdtFlag.registerBase(PriceClassificationFlag, ctor, tag);
    }
  }, {
    key: "deserialize",
    value: function deserialize(data) {
      return AdtFlag_1.AdtFlag.deserializeBase(PriceClassificationFlag, data);
    }
  }]);

  return PriceClassificationFlag;
}(AdtFlag_1.AdtFlag);

exports.PriceClassificationFlag = PriceClassificationFlag;
PriceClassificationFlag.TAG = '__PriceFlag__';
/**
 * Marks that a competitor price was originally classified as OUTLIER by automatic cleaning algorithm,
 * but there was too many of them (more than is set in configuration - outlierLimit), so it was reclassified as REGULAR.
 */

var TooManyOutliers =
/*#__PURE__*/
function (_PriceClassificationF) {
  _inherits(TooManyOutliers, _PriceClassificationF);

  function TooManyOutliers() {
    _classCallCheck(this, TooManyOutliers);

    return _possibleConstructorReturn(this, _getPrototypeOf(TooManyOutliers).apply(this, arguments));
  }

  _createClass(TooManyOutliers, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return TooManyOutliers;
}(PriceClassificationFlag);

exports.TooManyOutliers = TooManyOutliers;
TooManyOutliers.TAG = PriceClassificationFlag.register(TooManyOutliers);
/**
 * Marks that a competitor price was originally classified as PROMO by automatic cleaning algorithm,
 * but there was too many of them (more than is set in configuration - promoLimit), so it was reclassified as REGULAR.
 */

var TooManyPromos =
/*#__PURE__*/
function (_PriceClassificationF2) {
  _inherits(TooManyPromos, _PriceClassificationF2);

  function TooManyPromos() {
    _classCallCheck(this, TooManyPromos);

    return _possibleConstructorReturn(this, _getPrototypeOf(TooManyPromos).apply(this, arguments));
  }

  _createClass(TooManyPromos, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return TooManyPromos;
}(PriceClassificationFlag);

exports.TooManyPromos = TooManyPromos;
TooManyPromos.TAG = PriceClassificationFlag.register(TooManyPromos);